module.exports = require("./slot");
